import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { ClientUserData } from '@/common/types/client/user.type'
import { EstablishmentUserData } from '@/common/types/establishmentUsers.type'
import { UserRoundIcon } from 'lucide-react'

type AuthorEventableProps = {
  data: ClientUserData | EstablishmentUserData
}

const CompanyEventAuthor = ({ data: author }: AuthorEventableProps) => {
  return (
    <div className="flex gap-2 items-center">
      <ImageWithPlaceholder
        alt={author?.full_name}
        placeholderIcon={UserRoundIcon}
        className="size-6"
        iconClassName="size-4"
      />
      <p className="text-xs">{author?.full_name}</p>
    </div>
  )
}

export default CompanyEventAuthor
